// src/components/ShowsByArtist.js
import React from 'react';
import { useQuery, gql } from '@apollo/client';
import './ShowsByArtist.css';

const GET_SHOWS_BY_ARTIST = gql`
  query GetAllShows($filter: ShowFilterInput) {
    getAllShows(filter: $filter) {
      id
      title
      date
      startTime
      venueName
      manualVenueName
      venuePageId
    }
  }
`;

const ShowsByArtist = ({ artistPageId }) => {
  const { loading, error, data } = useQuery(GET_SHOWS_BY_ARTIST, {
    variables: { filter: { artistPageId: parseInt(artistPageId) } },
  });

  if (loading) return <p>Loading shows...</p>;
  if (error) return <p>Error loading shows: {error.message}</p>;

  if (data.getAllShows.length === 0) {
    return <p>No shows found for this artist.</p>;
  }

  return (
    <div className="shows-by-artist">
      {data.getAllShows.map((show) => (
        <div key={show.id} className="show-card">
          <h4>{show.title}</h4>
          <p>
            {new Date(show.date).toLocaleDateString(undefined, {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}{" "}
            {show.startTime && `@ ${show.startTime}`}
          </p>
          <p>
            📍 {show.venueName || show.manualVenueName || 'TBA'}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ShowsByArtist;
